const KEY = "raas.listStub";
const ALLOWED = new Set(["form", "block", "reject", "down"]);

export type ListStub = "form" | "block" | "reject" | "down";

const storage = (): Storage | null => {
  try {
    return typeof sessionStorage === "undefined" ? null : sessionStorage;
  } catch {
    return null;
  }
};

/** Reads `?listStub=` once. A missing param leaves the stored value alone. */
export function captureListStubFromLocation(search: string): void {
  const params = new URLSearchParams(search);
  if (!params.has("listStub")) return;
  const raw = (params.get("listStub") ?? "").trim().toLowerCase();
  const store = storage();
  if (!store) return;
  if (ALLOWED.has(raw)) store.setItem(KEY, raw);
  else store.removeItem(KEY);
}

export function captureListStubFromUrl(): void {
  if (typeof window === "undefined") return;
  captureListStubFromLocation(window.location.search);
}

export function getListStub(): ListStub | null {
  const raw = storage()?.getItem(KEY);
  return raw && ALLOWED.has(raw) ? (raw as ListStub) : null;
}

export function setListStub(value: ListStub): void {
  storage()?.setItem(KEY, value);
}
